var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},_vm._l((_vm.houseTypeConfigs),function(item,index){return _c('div',{key:'keyA'+index,staticClass:"item"},[_c('div',{staticClass:"desc"},[_vm._v(_vm._s(item.itemName))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }